import domReady from '@wordpress/dom-ready';
import manifest from './../manifest.json';

domReady(async () => {
	const filterPanelItemSelector = `.${manifest.blockJsClass}`;
	const filterPanelItem = document.querySelector(`.${manifest.blockJsClass}`);

	if (!filterPanelItem) {
		return;
	}

	const { FilterPanelToggle } = await import('./filter-panel-toggle');

	new FilterPanelToggle({
		filterPanelItem: filterPanelItem,
		filterPanelItemSelector: filterPanelItemSelector,
	}).init();
});
